export enum GeometricShape {
  CIRCLE = "CIRCLE",
  POLYGON = "POLYGON",
}
